let url = "https://api.skybuybd.com/v1/admin";
// let url = "http://192.168.0.103:3070/v1/admin";
export let cdnUrl = "https://cdnapi.skybuybd.com/v1/admin";
export let cdnUrlV2 = "https://cdnapi.skybuybd.com/v2/admin";
export let baseUrl = "https://api.skybuybd.com/v1";
export default url;
